var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.759 13.8968L9.62106 13.8968L9.62106 16.0347H11.759L11.759 13.8968ZM10.69 5.34488C11.278 5.34488 11.759 5.82592 11.759 6.41386V10.6898C11.759 11.2777 11.278 11.7588 10.69 11.7588C10.1021 11.7588 9.62106 11.2777 9.62106 10.6898V6.41386C9.62106 5.82592 10.1021 5.34488 10.69 5.34488V5.34488ZM10.69 21.3796C16.5908 21.3796 21.3799 16.5906 21.3799 10.6898C21.3799 4.78901 16.5908 -4.19617e-05 10.69 -4.19617e-05C4.78925 -4.19617e-05 0.000202179 4.78901 0.000202179 10.6898C0.000202179 16.5906 4.78925 21.3796 10.69 21.3796V21.3796Z",
    fill: "#B9C1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsDark);
export default __webpack_public_path__ + "static/media/alerts-dark.de9ff589ed9113065513210ef1e6dd54.svg";
export { ForwardRef as ReactComponent };